import { z } from 'zod';

export const CreateUserResourceLinkTypeSchema = z.object({
  name: z.string().min(1, 'Name cannot be empty').max(100, 'Name is too long'),
});

export type ICreateUserResourceLinkTypeDto = z.infer<
  typeof CreateUserResourceLinkTypeSchema
>;
